module.exports = __webpack_public_path__ + "img/icon-nav3_blue.9e0beca2.svg";